<template>
  <div>
    <!-- #region Table -->
    <CDataTable
      column-filter
      hover
      pagination
      size="sm"
      sorter
      table-filter
      :fields="tableFields"
      :items="tableItems"
      v-if="canShowTable"
    >
      <td
        slot="shortCode"
        slot-scope="{ item }"
        class="text-center"
      >
        <span class="ml-2 text-left">{{ item.shortCode }}</span>
      </td>
      <td
        slot="name"
        slot-scope="{ item }"
      >
        <span class="ml-2 text-left">{{ item.name }}</span>
      </td>
      <td
        slot="type"
        slot-scope="{ item }"
        class="text-center"
      >
        <span class="ml-2 text-left">{{ item.type | couponOptionTypeName }}</span>
      </td>
      <td
        slot="value"
        slot-scope="{ item }"
        class="text-right"
      >
        <span class="ml-2 text-left">{{ item.value | couponOptionValue(item.type) }}</span>
      </td>
      <td
        slot="description"
        slot-scope="{ item }"
      >
        <span class="ml-2 text-left">{{ item.description }}</span>
      </td>
      <td
        slot="status"
        slot-scope="{ item }"
        class="text-center"
      >
        <span class="ml-2 text-left">{{ item.status | CouponStatus }}</span>
      </td>
      <td
        slot="activated"
        slot-scope="{ item }"
        class="text-center"
      >
        <span class="ml-2 text-left">{{ item.activated | formatDate }}</span>
      </td>
      <td
        slot="count"
        slot-scope="{ item }"
        class="text-right"
      >
        <span class="ml-2 text-left">{{ item.count }}</span>
      </td>
      <td
        slot="used"
        slot-scope="{ item }"
        class="text-right"
      >
        <span class="ml-2 text-left">{{ item.used }}</span>
      </td>
      <td
        slot="remainCount"
        slot-scope="{ item }"
        class="text-right"
      >
        <span class="ml-2 text-left">{{ item.remainCount }}</span>
      </td>
    </CDataTable>
    <!-- #endregion Table -->

    <!-- #region Alert -->
    <CAlert
      color="danger"
      class="mt-3 text-center"
      v-if="notFound"
    >
      ご利用可能な割引はありません。
    </CAlert>
    <!-- #endregion Alert -->

    <!-- #region Modal -->
    <!-- #endregion Modal -->
    
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MemberDiscountListTable",

  props: {},

  data() {
    return {
       
      //#region Flag

      loading: false,

      //#endregion Flag


      //#region Table

      /** 一覧列名 */
      tableFields: [
        { key: "shortCode", label: "ショートコード", _classes: "text-center bg-light" },
        { key: "name", label: "割引名称", _classes: "text-center bg-light" },
        { key: "type", label: "割引種別", _classes: "text-center bg-light" },
        { key: "value", label: "割引金額/割引率", _classes: "text-center bg-light" },
        { key: "description", label: "説明", _classes: "text-center bg-light" },
        { key: "status", label: "ステータス", _classes: "text-center bg-light" },
        { key: "activated", label: "購入日", _classes: "text-center bg-light" },
        { key: "count", label: "回数", _classes: "text-center bg-light" },
        { key: "used", label: "使用回数", _classes: "text-center bg-light" },
        { key: "remainCount", label: "残回数", _classes: "text-center bg-light" },
      ],
      /** 一覧表示データ */
      tableItems: [],

      //#endregion Table


      //#region Response data

      discounts: [],
      user: {}

      //#endregion Response data

    }
  },

  computed: {

    /** 一覧表表示できるか？ */
    canShowTable() {
      return !this.loading && !this.notFound;
    },

    /** レスポンスデータが見つからないか？ */
    notFound() {
      return this.discounts.length < 1;
    },

    /** ユーザーUUIDがあるか？ */
    hasUuid() {
      console.log(this.uuid);
      return !this.uuid !== "";
    },

    /** ユーザーUUID */
    uuid() {
      return this.$route.params.uuid;
    },

    /** ログインユーザーのロール */
    loginUserRoles() {
      return this.$keycloak.realmAccess.roles;
    },

    /** 許可されているか */
    isAllowed() {
      if (!this.hasUuid) return false;
      if (this.loginUserRoles.includes('liberty_operator_admin')) return true;
      if (this.loginUserRoles.includes('liberty_operator')) return true;
      return false;
    },

  },

  methods: {

    //#region Event
    //#endregion Event


    //#region Request

    /** 会員割引一覧取得 */
    getUserDiscounts() {
      if (!this.isAllowed) return;

      const uuid = this.uuid;
      // FIXME: discountsが正式。API修正待ち。
      // const url = `/rest/users/uuid/${uuid}/discounts`;
      const url = `/rest/users/uuid/${uuid}/discount`;

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          const datas = resp.data;
          console.log(datas);

          this.discounts = datas;

          // 取得データを一覧表に流し込み
          this.pourTable(datas);
          console.log(this.tableItems);

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.PassError = err.response.status;
          this.loading = false;
        });

    },

    //#endregion Request

    //#region Method

    /**
     * 一覧表にデータを流し込む
     * @param datas
     */
    pourTable(datas) {
      this.clearTable();
      datas.forEach(data => {
        this.tableItems.push(
          {
            // note: data.coupon = 割引プランのオプション
            shortCode: data.shortCode,
            name: data.coupon.name,
            type: data.coupon.type,
            value: data.coupon.value,
            description: data.coupon.description,
            status: data.status,
            activated: data.activated,
            count: data.count,
            used: data.used,
            remainCount: data.count - data.used,
          }
        );
      });
    },

    /**
     * 一覧表をクリア
     */
    clearTable() {
      this.tableItems = [];
    },

    //#endregion Method

  },

  beforeMount() {
    this.getUserDiscounts();
  },

};
</script>
